import { Control } from 'react-hook-form';
import { useTranslation } from '../../../../translation/TranslationContext';
import { CsvTemplate, ExportOrderForm } from '../ExportOrderModal.types';
import { CSV_EXPORT_MODELS, FIELD_LABELS } from '../utils/exportOrder.consts';
import ExportOrderSelectField from './ExportOrderSelectField';

interface CsvContentProps {
  control: Control<ExportOrderForm>;
  isVerupOptionVisible: boolean;
  isModelOptionVisible: boolean;
}

const CsvContent = ({ control, isVerupOptionVisible, isModelOptionVisible }: CsvContentProps) => {
  const { translate } = useTranslation();
  const options = CSV_EXPORT_MODELS.filter(({ value }) => {
    if (value === CsvTemplate.VERUP) {
      return isVerupOptionVisible;
    }
    if (value === CsvTemplate.FILLED_MODEL) {
      return isModelOptionVisible;
    }
    return true;
  }).map(({ labelKey, value }) => ({
    label: translate(labelKey),
    value,
  }));

  return (
    <ExportOrderSelectField
      control={control}
      name="csvTemplate"
      label={translate(FIELD_LABELS.exportModel)}
      options={options}
      disabled={options.length === 1}
    />
  );
};

export default CsvContent;
